import { createStandardAction } from 'typesafe-actions';
import * as Types from './types';
import { IEditBulletinInput, INewBulletinInput, PoiType, BulletinStatusType, PoiId } from 'utils/entities';
import { IReportAddressData } from 'components/upload-bulletin/report-error-popup/interfaces';
import { INITIATE_SOURCE } from 'components/private-bulletin-promotion/types';
import { PromotionPlanInfo } from 'store/sagas/apiService/types';

export interface CreateListingAndPayForPlanParams {
  listing: INewBulletinInput;
  plan: PromotionPlanInfo;
  redirectUrl: string;
  initiateSource: INITIATE_SOURCE;
}

export interface NewListingParams {
  listing: INewBulletinInput;
  source?: 'wizardPaidPlanViaIframe' | 'wizardPaidPlanViaHostedFields' | 'wizardGrantPlan';
}

export interface EditListingParams {
  listing: IEditBulletinInput;
  isUploadFlow?: boolean;
}

export interface EditListingSilentParams {
  listing: IEditBulletinInput;
}

export interface ValidateListingDataParams {
  listing: IEditBulletinInput | INewBulletinInput;
  phone: string;
  isEdit: boolean;
  isBasicPlan: boolean;
}

export interface EditListingPromoteStatusParams {
  id: PoiId;
  promotedStatus: boolean;
  type: PoiType & ('bulletin' | 'project' | 'commercialBulletin' | 'commercialProject');
}

export interface EditListingStatusParams {
  type: PoiType & ('bulletin' | 'project' | 'commercialBulletin' | 'commercialProject');
  status: BulletinStatusType;
  id: PoiId;
  hideReason?: string;
  source?: string;
  isSubscription?: boolean;
}

export interface EditListingAssignedAgentParams {
  type: PoiType & ('bulletin' | 'project' | 'commercialBulletin' | 'commercialProject');
  id: PoiId;
  agentId: string;
  userId: string;
}

export const reportAddressErrorAction = createStandardAction(Types.REPORTING_ERROR_ADDRESS)<IReportAddressData>();
export const newListingAction = createStandardAction(Types.NEW_LISTING)<NewListingParams>();
export const createListingAndPayForPlanAction = createStandardAction(Types.CREATE_LISTING_AND_PAY_FOR_PLAN)<CreateListingAndPayForPlanParams>();
export const editListingAction = createStandardAction(Types.EDIT_LISTING)<EditListingParams>();
export const editListingSilentAction = createStandardAction(Types.EDIT_LISTING_SILENT)<EditListingSilentParams>();
export const editListingStatusAction = createStandardAction(Types.EDIT_LISTING_STATUS)<EditListingStatusParams>();
export const editListingPromoteStatusAction = createStandardAction(Types.EDIT_LISTING_PROMOTE_STATUS)<EditListingPromoteStatusParams>();
export const validateUploadPhoneAction = createStandardAction(Types.VALIDATE_PHONE)<ValidateListingDataParams>();
export const listingsTableInlineUpdateSuccess = createStandardAction(Types.LISTINGS_TABLE_INLINE_UPDATE_SUCCESS)();
export const editListingAssignedAgentAction = createStandardAction(Types.EDIT_LISTING_ASSIGNED_AGENT)<EditListingAssignedAgentParams>();
